import React, { createContext, useContext, useState, useEffect } from "react"
import API from "../api/axios"

const ConfigContext = createContext({ paymentEnabled: false })

export const ConfigProvider = ({ children }) => {
  const [config, setConfig] = useState({ paymentEnabled: false })

  useEffect(() => {
    API.get("/config")
      .then(res => setConfig(res.data))
      .catch(() => setConfig({ paymentEnabled: false }))
  }, [])

  return (
    <ConfigContext.Provider value={config}>
      {children}
    </ConfigContext.Provider>
  )
}

export const useConfig = () => useContext(ConfigContext)
